import { useEffect } from "react";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import {CustomAutocomplete} from '@/shared/components/ui';
import { UsuariosSistemaGET } from "@/shared/interfaces";
import { useFetchGetAreascontrolcambios, useFetchPostAsignarAreaAprobador } from "@/shared/actions";
import { Areascontrolcambios } from "../../types";
import { useForm } from "react-hook-form";
import ModalForm from "@/shared/components/ui/ModalForm";

type ModalAsignarAreaAprobadorProps = {
    open: boolean;
    onClose: () => void;
    usuario: UsuariosSistemaGET | null;
}
type FormValues = {
    areaId : string;
}

export default function ModalAsignarAreaAprobador({ 
    open,
    onClose,
    usuario
} : ModalAsignarAreaAprobadorProps) {
    const {data: areasData, isLoading: isLoadingAreas} = useFetchGetAreascontrolcambios({page:0, size: 1000,});
    const asignarMutation = useFetchPostAsignarAreaAprobador();
    const form = useForm<FormValues>({
        defaultValues: {areaId: ''}
    })
    const {handleSubmit, control, reset} = form;

    useEffect(()=>{
        if(!open) reset({areaId: ''});

    }, [open,reset]);

    const onSubmit = (values: FormValues) => {
        if(!usuario?.id) return;
        asignarMutation.mutate(
            {areaId: values.areaId, usuarioId: usuario.id},
            {onSuccess: onClose}
        );  
    };
    return (
        <ModalForm
            open={open}
            onClose={onClose}
            title={usuario ? `Asignar área a ${usuario.full_name || usuario.username}` : 'Asignar área'}
            maxWidth={500}
        >
            <Box component={"form"} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>
                 <Stack spacing={3}>
                    <CustomAutocomplete<Areascontrolcambios>
                        name="areaId"
                        label="Área"
                        control={control}
                        options={areasData?.data || []}
                        valueKey="nombre"
                        actualValueKey="areaId"
                        defaultValue=""
                        isLoadingData={isLoadingAreas}
                        error={form.formState.errors.areaId}
                        helperText={form.formState.errors.areaId?.message ?? ''}
                        required
                    />

                    <Box display="flex" justifyContent="flex-end" gap={2}>
                        <Button variant="outlined" onClick={onClose} disabled={asignarMutation.isPending}>
                        Cancelar
                        </Button>
                        <Button type="submit" variant="contained" disabled={asignarMutation.isPending}>
                        {asignarMutation.isPending ? <CircularProgress size={20} /> : 'Guardar'}
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </ModalForm>
    );
};